import { NgModule } from '@angular/core';
import { QrCodeViewComponent } from './qr-code-view.component';



@NgModule({
  declarations: [QrCodeViewComponent],
  imports: [
  ],
  exports: [QrCodeViewComponent]
})
export class QrCodeViewModule { }
